export const getFirstFormFields = ({
  eventDetails,
  fetchOptions,
  handleChange,
  // fetchDefaultOptions
}) => {
  return [
    {
      label: "Organiser Name",
      id: "organiser_name",
      placeholder: "Organiser name",
      loadOptions: fetchOptions,
      // default: fetchDefaultOptions,
      
      isSearchable: true,
      type: "select_search",
      value: eventDetails?.organiser_name,
      default: eventDetails?.organiser_name,
      required: true,
      loading: true,
      onChange: handleChange("organiser_name"),
    },
    {
      label: "Event Name",
      id: "event_name",
      placeholder: "Event Name",
      type: "text",
      value: eventDetails?.event_name,
      required: true,
      onChange: handleChange("event_name"),
    },
    // {
    //   label: "Event Description",
    //   id: "event_description",
    //   placeholder: "Event Description",
    //   type: "textArea",
    //   value: eventDetails?.event_description,
    //   required: false,
    //   onChange: handleChange("event_description"),
    // },
    {
      label: "Venue",
      id: "venue",
      placeholder: "Enter Venue",
      type: "places",
      value: eventDetails?.venue,
      required: true,
      onChange: handleChange("venue"),
      onPlaceSelected: handleChange("venue"),
    },
  ];
};

export const getSecondFormFields = ({ eventDetails, handleChange }) => {
  const startsDate = eventDetails?.starts ? new Date(eventDetails.starts) : null;
  const endsMinDate = startsDate || new Date();
  const maxDate = new Date();
  const endsMaxDate = new Date();
  maxDate.setDate(maxDate.getDate() + 360)

  return [
    {
      label: "Starts",
      id: "starts",
      placeholder: "Pick Date",
      type: "dateTimePicker",
      selected: eventDetails?.starts,
      minDate: new Date(),
      required: true,
      onChange: handleChange("starts"),
      selectedHours: eventDetails?.startHours,
      onHoursChange: handleChange("startHours"),
      selectedMinutes: eventDetails?.startMinutes,
      onMinutesChange: handleChange("startMinutes"),
    },
    {
      label: "Ends",
      id: "ends",
      placeholder: "Pick Date",
      type: "dateTimePicker",
      selected: eventDetails?.ends,
      onChange: handleChange("ends"),
      // minDate: new Date(eventDetails?.starts),
      minDate: endsMinDate, 
      // maxDate: endsMaxDate, 
      required: true,
      selectedHours: eventDetails?.endHours,
      onHoursChange: handleChange("endHours"),
      selectedMinutes: eventDetails?.endMinutes,
      onMinutesChange: handleChange("endMinutes"),
    },
  ];
};

export const getThirdFormFields = ({ eventDetails, handleChange }) => {
  const options = [
    { value: 1, label: "Leanne Graham" },
    { value: 2, label: "Ervin Howell" },
  ];

  return [
    {
      label: "Last Entry Time",
      id: "last_entry_time",
      placeholder: "Enter Last Entry Time",
      type: "dateTimePicker",
      selected: eventDetails?.last_entry_time,
      required: true,
      // maxDate:new Date(eventDetails?.starts),
      maxDate:new Date(eventDetails?.ends),
      minDate:new Date(),
      options,
      onChange: handleChange("last_entry_time"),
      selectedHours: eventDetails?.lastEndHours,
      onHoursChange: handleChange("lastEndHours"),
      selectedMinutes: eventDetails?.lastEndMinutes,
      onMinutesChange: handleChange("lastEndMinutes"),
    },
    {
      label: "Age Restriction",
      id: "age_restrictions",
      placeholder: "Event Age Restrictions",
      type: "number",
      min: "18",
      step: 1,
      value: eventDetails?.age_restrictions,
      pattern: "[0-9]*",
      onKeyDown: (e) => e.key === "e" && e.preventDefault(),
      required: true,
      options,
      onChange: handleChange("age_restrictions"),
    },
    {
      label: "Booking Fee Percentage (%)",
      id: "booking_fee_percentage",
      placeholder: "e.g. 10",
      type: "number",
      min: "0",
      max: "100",
      step: "0.1",
      value: eventDetails?.booking_fee_percentage,
      required: true,
      onChange: handleChange("booking_fee_percentage"),
    },
    {
      label: "Enable Installments",
      subLabel: "Allow customers to pay in installments for this event.",
      id: "installments_enabled",
      type: "checkbox",
      checked: eventDetails?.installments_enabled || false,
      onChange: handleChange("installments_enabled", (e) => e?.target?.checked),
    },
    ...(eventDetails?.installments_enabled
      ? [
          {
            label: "Installment Plans",
            id: "installment_plans",
            placeholder: "Select plans...",
            type: "select",
            isMulti: true, // Requires modifying the Select component to support isMulti if not already doing so
            value: eventDetails?.installment_plans || [],
            options: [
              { label: "2 Months", value: "installment_2" },
              { label: "3 Months", value: "installment_3" },
              { label: "6 Months", value: "installment_6" },
              { label: "12 Months", value: "installment_12" },
            ],
            onChange: handleChange("installment_plans"),
          },
          {
            label: "Installment Cutoff Days",
            subLabel: "Number of days before event when installments are no longer available.",
            id: "installment_cutoff_days",
            placeholder: "e.g. 90",
            type: "number",
            min: "0",
            step: "1",
            value: eventDetails?.installment_cutoff_days,
            required: true,
            onChange: handleChange("installment_cutoff_days", Number),
          },
          {
            label: "Installment Billing Type",
            subLabel: "Choose how installment billing dates are calculated.",
            id: "installment_billing_type",
            type: "radio",
            required: true,
            radioClasses: {
              display: "inline-flex",
              alignItems: "center",
            },
            selectedValue: eventDetails?.installment_billing_type || "monthly_cycle",
            options: [
              { label: "1st of Every Month", value: "calendar_monthly" },
              { label: "Every 30 Days", value: "monthly_cycle" },
            ],
            onChange: handleChange("installment_billing_type"),
          },
        ]
      : []),
  ];
};

export const getFourthFormFields = ({ eventDetails, handleChange }) => {
  return [
    {
      label: "Refund Requests",
      subLabel:
        "Disable or enable refund requests for this event. This will override the Refund Requests setting on your Flow Page.",
      id: "has_refund",
      placeholder: "has_refund",
      required: true,
      type: "radio",
      radioClasses: {
        display: "inline-flex",
        alignItems: "center",
        // marginTop: "1.3rem",
      },
      selectedValue: eventDetails?.has_refund,
      options: [
        { label: "Disabled", value: false },
        { label: "Enabled", value: true },
      ],
      onChange: handleChange("has_refund"),
    },
  ];
};

export const getImageFormField = ({ eventDetails, handleChange }) => {
  return [
    {
      label:"",
        // "Events with images are noticed by more customers, and usually sell more tickets.",
      id: "event_image",
      type: "image",
      value: eventDetails?.event_image,
      onChange: handleChange("event_image"),
      required: true,
    },
  ];
};
